<template>
  <div v-loading="loading" class="new_guest_gift_page">
    <div class="new_guest_gift_card">
      <div class="card_title">新客赠礼配置</div>

      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="88px"
        size="mini"
        class="gift_form"
      >
        <el-form-item label="电子票券" prop="ticketId">
          <el-select
            v-model="formData.ticketId"
            filterable
            placeholder="请选择电子票券"
            @change="syncTicketName"
          >
            <el-option
              v-for="item in firstTicketOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="第二票券" prop="ticketId2">
          <el-select
            v-model="formData.ticketId2"
            filterable
            clearable
            placeholder="请选择第二电子票券（选填）"
            @change="syncTicketName"
          >
            <el-option
              v-for="item in secondTicketOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="formData.name"
            placeholder="请输入名称"
          />
        </el-form-item>

        <el-form-item label="图片" prop="imgUrl">
          <div class="upload_wrap">
            <uploadPic
              ref="uploadPic"
              :my-url="formData.imgUrl"
              :width="80"
              :height="80"
              :enable-preview-delete="true"
              @upLoadImage="handleUploadSuccess"
            />
          </div>
          <div class="image_tip">
            图片推荐比例为1:1，尺寸不要超过300KB，使用PNG格式，背景透明
          </div>
        </el-form-item>

        <el-form-item label="是否启用" prop="status">
          <el-radio-group v-model="formData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            :loading="submitLoading"
            @click="submitForm"
          >
            更新
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import uploadPic from '@/components/Upload/UploadPic'
import { getTicketManList } from '@/api/ticketMan'
import { getNewGuestGift, saveNewGuestGift } from '@/api/activity/newGuestGift'

export default {
  name: 'NewGuestGift',
  components: { uploadPic },
  data() {
    return {
      loading: false,
      submitLoading: false,
      ticketOptions: [],
      formData: {
        ticketId: '',
        ticketName: '',
        ticketId2: '',
        ticketName2: '',
        name: '',
        imgUrl: '',
        status: 1
      },
      rules: {
        ticketId: [
          { required: true, message: '请选择电子票券', trigger: 'change' }
        ],
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        imgUrl: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择是否启用', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.initPageData()
  },
  computed: {
    // 第一张可选项：排除第二张已选
    firstTicketOptions() {
      return this.ticketOptions.filter(
        (item) =>
          !this.formData.ticketId2 ||
          String(item.value) !== String(this.formData.ticketId2)
      )
    },
    // 第二张可选项：排除第一张已选
    secondTicketOptions() {
      return this.ticketOptions.filter(
        (item) =>
          !this.formData.ticketId ||
          String(item.value) !== String(this.formData.ticketId)
      )
    }
  },
  methods: {
    initPageData() {
      this.loading = true
      Promise.all([this.loadTicketOptions(), this.loadGiftConfig()])
        .then(() => {
          this.syncTicketName()
        })
        .catch((err) => {
          this.$message.error(err || '加载失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    loadTicketOptions() {
      return getTicketManList().then((res) => {
        const list = Array.isArray(res) ? res : (res && res.rows) || []
        this.ticketOptions = list
          .filter((item) => Number(item.status) === 1)
          .map((item) => ({
            label: item.name,
            value: String(item.id)
          }))
      })
    },
    loadGiftConfig() {
      return getNewGuestGift().then((res) => {
        if (!res) return
        this.formData = {
          ...this.formData,
          ...res,
          ticketId:
            res.ticketId === undefined || res.ticketId === null
              ? ''
              : String(res.ticketId),
          ticketId2:
            res.ticketId2 === undefined ||
            res.ticketId2 === null ||
            Number(res.ticketId2) === 0
              ? ''
              : String(res.ticketId2),
          status: Number(res.status) === 0 ? 0 : 1
        }
      })
    },
    syncTicketName() {
      const ticket = this.ticketOptions.find(
        (item) => String(item.value) === String(this.formData.ticketId)
      )
      if (ticket) {
        this.formData.ticketName = ticket.label
      } else {
        this.formData.ticketId = ''
        this.formData.ticketName = ''
      }

      const ticket2 = this.ticketOptions.find(
        (item) => String(item.value) === String(this.formData.ticketId2)
      )
      if (this.formData.ticketId2 && ticket2) {
        this.formData.ticketName2 = ticket2.label
      } else {
        this.formData.ticketId2 = ''
        this.formData.ticketName2 = ''
      }
    },
    handleUploadSuccess(url) {
      this.formData.imgUrl = url
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.validateField('imgUrl')
        }
      })
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return

        const payload = {
          ticketId: Number(this.formData.ticketId),
          ticketName: this.formData.ticketName,
          ticketId2: this.formData.ticketId2
            ? Number(this.formData.ticketId2)
            : null,
          ticketName2: this.formData.ticketId2
            ? this.formData.ticketName2
            : '',
          name: this.formData.name,
          imgUrl: this.formData.imgUrl,
          status: this.formData.status
        }

        if (!payload.ticketName) {
          this.$message.warning('请选择启用状态的电子票券')
          return
        }

        this.submitLoading = true
        saveNewGuestGift(payload)
          .then(() => {
            this.$message.success('更新成功')
            this.loadGiftConfig()
          })
          .catch((err) => {
            this.$message.error(err || '更新失败，请稍后重试')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.new_guest_gift_page {
  padding: 20px;
  box-sizing: border-box;
}

.new_guest_gift_card {
  width: 760px;
  min-height: 480px;
  padding: 32px 24px;
  box-sizing: border-box;
  background: #f4f4f4;
  border: 1px solid #e8e8e8;
}

.card_title {
  margin-bottom: 26px;
  font-size: 28px;
  font-weight: 700;
  color: #1f1f1f;
}

.gift_form {
  width: 560px;
}

.el-select,
.el-input {
  width: 340px;
}

.upload_wrap {
  display: inline-flex;
}

.image_tip {
  margin-top: 8px;
  margin-left: 10px;
  font-size: 12px;
  color: #909399;
}
</style>
